/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCubeRestructure = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M8 2h8v6h-3v1h5v4h3v6h-8v-6h3v-2H8v1.446l4 2.5v5.108L7 23.18l-5-3.125v-5.108l4-2.5V9h5V8H8zM7 14.18 4.887 15.5 7 16.82l2.113-1.32zm3 3.124-2 1.25v1.642l2-1.25zm-4 2.892v-1.642l-2-1.25v1.642zM10 4v2h4V4zm5 11v2h4v-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCubeRestructure as CubeRestructure };
